import echarts from 'echarts'
import merge from 'lodash/merge'
let setAdaption = function (size, setPro) {
    if(!setPro){
        // 默认值
        return 10 * size
    }
    return setPro * size;
};

export const linebarOption = (setPro, element_id, data) => {
    let chart = echarts.init(document.getElementById(element_id))
    // const legendData = data.map(v => v.name)
    const seriesData = data && data.seriesData.map((v) =>{
      return {
        name: v.name,
        itemStyle: {
             normal: {
                 color: v.barcolor
             }
         },
         lineStyle: {
             //折线颜色
             normal: {
               width: setAdaption(0.1, setPro),
               color: v.linecolor,
             },
           },
           itemStyle:{
             //图例、拐点
            color: v.linecolor,
        },
         data: v.data,
      }
    }) 
  //   const seriesData = data.map((v) =>{
  //    return {
  //       name: v.name,
  //       itemStyle: {
  //           normal: {
  //               color: v.barcolor
  //           }
  //       },
  //       lineStyle: {
  //           //折线颜色
  //           normal: {
  //             width: setAdaption(0.1, setPro),
  //             color: v.linecolor,
  //           },
  //         },
  //         itemStyle:{
  //           //图例、拐点
  //          color: v.linecolor,
  //      },
  //       data: v.data,
  //    }
  //  }) 
    const myOption = {
        series: seriesData,
        xAxis: data && {data: data.xAxisData}

    }
    let option = {
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
                // label: {
                //     show: true
                // }
            },
        //     position: function(point, params, dom, rect, size) {
        //       //其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
        //       var x = point[0]; //
        //       var y = point[1];
        //       var viewWidth = size.viewSize[0];
        //       var viewHeight = size.viewSize[1];
        //       var boxWidth = size.contentSize[0];
        //       var boxHeight = size.contentSize[1];
        //       var posX = 0; //x坐标位置
        //       var posY = 0; //y坐标位置
  
        //       if (x < boxWidth) { //左边放不开
        //           posX = 5;
        //       } else { //左边放的下
        //           posX = x - boxWidth;
        //       }
  
        //       if (y < boxHeight) { //上边放不开
        //           posY = 5;
        //       } else { //上边放得下
        //           posY = y - boxHeight;
        //       }
  
        //       return [posX, posY];
  
        //   },
            formatter: function (params) {
                  var str = '';//声明一个变量用来存储数据
                  str += params[0].name + '</br>';
                  //图显示的数据较多时需要循环数据，这样才可以成功的给多条数据添加单位
                  for (var i = 0; i < params.length; i++) {
                      if(i <= 1){
                          str +=  `<p style="display: flex;-webkit-box-align: center;align-items: center;margin:4px 0 0 0;padding:0;">
                                <span style="display:inline-block;width:10px;height:10px;
                                     background-color:`+params[i].color+`;margin-right:3px">
                                </span>
                                <span style="display:inline-block;margin-right:15px;font-size:0.6rem
                                     line-height:16px;width:130px;color: #fff;">`+params[i].seriesName + ' : ' +`
                                </span>`
                                +'&nbsp'+params[i].data + '%' + '</br>';
                      } else {
                            str +=  `<p style="display: flex;-webkit-box-align: center;align-items: center;
                                margin:4px 0 0 0;padding:0;">
                                <span style="display:inline-block;width:13px;height:3px;
                                     background-color:`+params[i].color+`;margin-right:3px">
                                </span>
                                <span style="display:inline-block;margin-right:15px;font-size:0.6rem
                                     line-height:16px;width:130px;color: #fff;">`+params[i].seriesName + ' : ' +`
                                </span>`
                                +'&nbsp'+params[i].data + '%' + '</br>';
                      }
                          
                  }
                  return str;
              },
        },
        grid: {
            left: "7%",
            top: "12%",
            right: "7%",
            bottom: "22%"
        },
        legend: [
            {
                top: '3%',
                left:'center',
                data:['信用扣分任务量占比', '前一年同比数据'],
                icon: 'rect',
                      itemWidth: 10,
                      itemHeight: 10,
                      textStyle: {
                          fontSize: setAdaption(0.6, setPro),
                          color: "rgba(151, 151, 151, 1)",
                          padding: [3, 20, 0, 0]
                      }
            },
            {
                top: '3%',
                right:'16%',
                data:['信用扣分率趋势'],
                icon: 'roundRect',
                      itemWidth: 13,
                      itemHeight: 3,
                      textStyle: {
                          fontSize: setAdaption(0.6, setPro),
                          color: "rgba(151, 151, 151, 1)",
                          padding: [3, 20, 0, 0]
                      }
            }
        ],
        xAxis: {
            data: [],
             //x轴线
              axisLine: {
                show: true,
                lineStyle: {
                  color: "rgba(151, 151, 151, 1)",
                  opacity: 0.8,
                  width: 1,
                  type: "solid",
                },
              },
            axisTick: {
                show: false, //隐藏X轴刻度
            },
            axisLabel: {
                textStyle: {
                  color: "rgba(255,255,255,0.4)",
                  fontSize: setAdaption(0.6, setPro),
                },
            }
        },
        yAxis: [{
                type: "value",
                name: "%",
                nameTextStyle: {
                color: "rgba(255, 255, 255, .4)",
                fontSize: setAdaption(0.6, setPro),
                padding: [0, 0, 0, -26],
              },
                 //轴线
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                lineStyle: {
                  color: "rgba(216, 216, 216, .2)",
                  type: "dotted",
                },
              },
                axisLabel:{
                textStyle: {
                  color: "rgba(255,255,255,0.4)",
                  fontStyle: "normal",
                  fontSize: setAdaption(0.6, setPro),
                    },
                },
            },
            {
                type: "value",
                name: "%",
                nameTextStyle: {
                color: "rgba(255, 255, 255, .4)",
                fontSize: setAdaption(0.6, setPro),
                padding: [0, -16, 0, 0],
              },
                 //轴线
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                lineStyle: {
                  color: "rgba(216, 216, 216, .2)",
                  type: "dotted",
                },
              },
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: "rgba(255,255,255,0.4)",
                        fontStyle: "normal",
                    }
                }
            }
        ],
        series: [{
                name: "信用扣分任务量占比",
                type: "bar",
                barGap: '10%', //双柱间距离
                barWidth: setAdaption(1, setPro),
                itemStyle: {
                    normal: {
                        color: 'rgba(24, 144, 255, 1)'
                    }
                },
                data: []
            },
            {
                name: "前一年同比数据",
                type: "bar",
                barWidth: setAdaption(1, setPro),
                itemStyle: {
                    normal: {
                        color: 'rgba(69, 218, 209, 1)'
                    }
                },
                data: []
            },
            {
                name: "信用扣分率趋势",
                type: "line",
                yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
                showAllSymbol: true, //显示所有图形。
                symbol: "circle", //标记的图形为实心圆
                symbolSize: 6, //标记的大小
                itemStyle: {
                    //折线拐点标志的样式
                    color: "rgba(255, 169, 64, 1)",
                    borderColor: "rgba(255, 169, 64, 1)",
                    width: 2,
                },
                lineStyle: {
                    color: "rgba(255, 169, 64, 1)",
                    width: 2,
                    shadowBlur: 2
                },
                 //鼠标经过时拐点样式
                  emphasis: {
                      itemStyle:{
                          borderWidth:2,
                          borderColor:"rgba(255, 169, 64, 1)",
                          //拐点颜色
                          color: "#fff",
                        },
                  },
                data: []
            }
        ]
    }
    const finalSeries = merge(option, myOption)

    chart.setOption(finalSeries)
    // 设置toolTip轮播效果
    let timer = null, index = 0, data_len = option.series[0].data.length;
    function autoTip() {
        // clearInterval(timer)
        timer = setInterval(() => {
            chart.dispatchAction({
                type: 'showTip',
                seriesIndex: 0,
                dataIndex: index
            })
            index++;
            if (index >= data_len) {
                index = 0;
            }
        }, 3000)
    }
    autoTip()

    return chart
}